import React, { useContext, useEffect, useState } from "react";
import { MedintDoctorData } from "../../services/medintInterfaces";
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Box,
  CardActionArea,
  TextField,
  CircularProgress,
  Pagination,
  Stack,
} from "@mui/material";
import "../../css/doctorsList.css";
import doctorImage from "../../assets/Avatar=Medico 1.svg";
import doctorImage2 from "../../assets/Avatar=Medico 2.svg";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { MedintDataContext } from "./Context/MedintContextWrapper";
import { ReactComponent as AddIcon } from "../../assets/icons/MedintAddIcon.svg";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// const useLocalStorageState = (initialState: any, key: any) => {
//   // lazy evaluation, accesso al dato tramite una callback di funzione
//   const [value, setValue] = useState(() => {
//     const storedValue = localStorage.getItem(key);
//     // console.log(storedValue);
//     return storedValue ? JSON.parse(storedValue) : initialState;
//   });

//   useEffect(() => {
//     localStorage.setItem(key, JSON.stringify(value));
//   }, [value, key]);

//   return [value, setValue];
// };

const DoctorsList = () => {
  const [filteredDoctors, setFilteredDoctors] = useState<MedintDoctorData[]>(
    []
  );
  const [initial, setInitial] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [availableInitials, setAvailableInitials] = useState<Set<string>>(
    new Set()
  );
  const [isTokenAvailable, setIsTokenAvailable] = useState(false);
  //Stato per gestire la paginazione corrente delle card
  const [currentPage, setCurrentPage] = useState(1);
  //Valore massimo di card per pagina
  const cardsPerPage = 50;
  // const [selectedDoctor, setSelectedDoctor] = useLocalStorageState(
  //   undefined,
  //   "Dottore selezionato"
  // );

  const context = useContext(MedintDataContext)!;

  // useEffect che mira a valorizzare delle liste che saranno necessarie all'uso su tutto medint
  useEffect(() => {
    if (context) {
      context.validateData();
    }
  }, []);

  // const getRandomColors = () => {
  //   const colors = ["#211C84", "#2973B2", "#4D55CC", "#7AB2D3"];
  //   const randomIndex = Math.floor(Math.random() * colors.length);
  //   return colors[randomIndex];
  // };

  // const stringAvatar = (fullName: string) => {
  //   // Rimuove tutto ciò che è dentro le parentesi quadre, in modo da evitare avatar con iniziali ["DISAB"] ecc
  //   const cleaned = fullName.replace(/\[.*?\]/g, "").trim();

  //   const names = cleaned.split(" ").filter(Boolean);

  //   const initials =
  //     names.length >= 2 ? `${names[0][0]}${names[1][0]}` : names[0]?.[0] || "?";

  //   return {
  //     sx: {
  //       bgcolor: getRandomColors(),
  //       width: 76,
  //       height: 76,
  //       fontWeight: "bold",
  //     },
  //     children: initials.toUpperCase(),
  //   };
  // };

  const updateFiltersAndFetch = () => {
    if (context.doctorsData) {
      setFilteredDoctors(context.doctorsData);

      // Creo un set di iniziali per filtrare la lista medici con le iniziali presenti
      const initials = new Set<any>(
        context.doctorsData.map((doctor: any) => {
          // controlli per evitare o gestire campi vuoti o nulli
          if (doctor.nome) {
            return doctor.nome[0].toUpperCase();
          }

          if (!doctor.nome) {
            if (doctor.cognome) {
              const str = doctor.cognome;
              const result = str.replace(/\[.*?\]\s*/, "").trim();
              return result[0].toUpperCase();
            }
          }
          return console.log("skipped");
        })
      );
      setAvailableInitials(initials);
    }
  };

  useEffect(() => {
    // Con AuthGuard, l'utente e' gia' autenticato quando raggiunge questa pagina
    setIsTokenAvailable(true);
  }, []);

  // fetch che registra i cambiamenti del dottore selezionati per ricerca
  useEffect(() => {
    updateFiltersAndFetch();
  }, [context.doctorsData]);

  const handleLetterClick = (letter: string) => {
    if (context.doctorsData) {
      setInitial(letter);
      const filtered = context.doctorsData.filter((doctor) =>
        doctor.cognome.startsWith(letter)
      );
      setFilteredDoctors(filtered);
    }
  };

  const handleResetFilter = () => {
    setInitial("");
    setSearchTerm("");
    context.doctorsData
      ? setFilteredDoctors(context.doctorsData)
      : console.log("doctor data non trovato");
    setSearchMode(false);
  };

  const handleSearchClick = () => {
    setSearchMode(true);
    setInitial("");
    setSearchTerm("");
    context.doctorsData
      ? setFilteredDoctors(context.doctorsData)
      : console.log("doctor data non trovato");
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    if (context.doctorsData) {
      const filtered = context.doctorsData.filter((doctor) => {
        const nome = (doctor.nome || "").trim().toLowerCase();
        const cognome = (doctor.cognome || "").trim().toLowerCase();
        const search = searchTerm.trim().toLowerCase();

        const fullName1 = `${nome} ${cognome}`.replace(/\s+/g, "");
        const fullName2 = `${cognome} ${nome}`.replace(/\s+/g, "");
        const normalizedSearch = search.replace(/\s+/g, "");

        return (
          fullName1.includes(normalizedSearch) ||
          fullName2.includes(normalizedSearch)
        );
      });
      setFilteredDoctors(filtered);
    }
  };

  const navigate = useNavigate();

  const handleDoctorClick = (doctor: any) => {
    localStorage.setItem("Dottore selezionato", JSON.stringify(doctor));
    context.setSelectedDoctor(doctor);
    navigate(`/medint/${doctor["codice medico"]}`, {
      state: { selectedDoctor: doctor },
    });
  };

  useEffect(() => {
    localStorage.removeItem("Dottore selezionato");
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const paginatedDoctors = filteredDoctors.slice(
    indexOfFirstCard,
    indexOfLastCard
  );

  const navigateToNewDoctor = () => {
    navigate(`/medint`);
  };

  return (
    <>
      <Helmet>
        <title>Lista medici</title>
      </Helmet>
      <Box display="flex" flexDirection="column">
        <Box className="alphabet-filter">
          <Box className="alphabet-filter-header">
            <Typography
              variant="subtitle1"
              component="div"
              className="lettera"
              sx={{ fontWeight: "bold" }}
            >
              Ricerca per {searchMode ? "nome" : "lettera"}
            </Typography>
            <Box sx={{ flex: 1 }} />
            <Button
              variant="outlined"
              color="primary"
              style={{paddingRight: 10, paddingLeft: 8,}}
              sx={{ marginRight: 2}}
            >
              Stampa
            </Button>
            <Button
              variant="contained"
              onClick={() => navigateToNewDoctor()}
              style={{ paddingRight: 10, paddingLeft: 8 }}
              sx={{
                height: "30px",
                width: "auto",
                borderRadius: "4px",
                display: "flex",
                gap: 1,
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              <Stack gap={1} direction={"row"}
                  >
                    <AddIcon className="medintIconContained" />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Aggiungi Medico
                    </Typography>
                  </Stack>
            </Button>
          </Box>
          {!searchMode ? (
            <Box className="alphabet-letters">
              {alphabet.map((letter) => (
                <Button
                  key={letter}
                  onClick={() => handleLetterClick(letter)}
                  disabled={!availableInitials.has(letter)} // Disabilita se la lettera non è presente
                  sx={{
                    color: availableInitials.has(letter)
                      ? "#006333"
                      : "#A9A9A9",
                    pointerEvents: availableInitials.has(letter)
                      ? "auto"
                      : "none",
                  }}
                >
                  {letter}
                </Button>
              ))}
            </Box>
          ) : (
            <TextField
              label="Nome medico"
              variant="outlined"
              autoFocus={searchMode}
              fullWidth
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
          )}
          <Box className="alphabet-filter-header">
            <Button style={{ fontWeight: "bold" }} onClick={handleResetFilter}>
              Reset
            </Button>
            {!searchMode && (
              <Box
                className="alphabet-filter-header"
                sx={{ display: "flex", justifyContent: "flex-end", gap: 3 }}
              >
                <Button
                  style={{
                    color: "#2E83C4",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  onClick={handleSearchClick}
                >
                  Vuoi cercare per nome?
                </Button>
              </Box>
            )}
          </Box>
        </Box>
        {context.doctorsData && (
          <Box className="cards-container">
            <Grid container spacing={2} className="grid">
              {paginatedDoctors.map((doctor, index) => {
                return (
                  <Grid item xs={12} sm={6} md={3} key={doctor.pkey}>
                    <Card
                      className="provaCard"
                      style={{ border: "none", boxShadow: "none" }}
                      onClick={() => {
                        handleDoctorClick(doctor);
                      }}
                    >
                      <CardActionArea>
                        <Box display="flex" justifyContent="center">
                          <CardMedia
                            component="img"
                            image={index % 2 === 0 ? doctorImage : doctorImage2}
                            title={`${doctor.nome} ${doctor.cognome}`}
                            className="cardMediaTest"
                          />
                        </Box>
                        <CardContent className="cardScrollable">
                          <Box textAlign="center">
                            <Typography
                              variant="h6"
                              component="div"
                              className="typographyTestTitle"
                            >
                              {`${doctor.cognome} ${doctor.nome} `}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              className="typographyTest"
                              mt={1}
                            >
                              Specialista in {doctor.specializzazione || ""}
                            </Typography>
                          </Box>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
            <Box display="flex" justifyContent="center" mt={3}>
              <Pagination
                count={Math.ceil(filteredDoctors.length / cardsPerPage)}
                page={currentPage}
                onChange={(event, value) => setCurrentPage(value)}
                color="primary"
                shape="rounded"
              />
            </Box>
          </Box>
        )}
        {context.doctorsData ? (
          context.doctorsData.length === 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 1000,
              }}
            >
              <CircularProgress size="6rem" />
            </Box>
          )
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};

export default DoctorsList;
